import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import {Record, Map} from 'immutable';
import CrmOpportunityActions from 'actions/crm-opp-ui/CrmOpportunityActions';

@immutableStore
class CrmOpportunityStore {
  constructor() {
    this.state = new Record({
      // most recent fetched opportunity
      opportunity: null,

      // all fetched opportunities.
      opportunities: Map(),

      searchTerm: null,
      searchResults: null,
      isSearching: false,

      stages: null,
    })();

    this.bindActions(CrmOpportunityActions);
  }

  onSearchOpportunities(term) {
    this.setState({
      isSearching: true,
      searchTerm: term,
    });
  }

  searchOpportunitiesSuccess(entities) {
    this.setState({
      isSearching: false,
      searchResults: entities,
    });
  }

  searchOpportunitiesError(response) {
    console.error(response);
    this.setState({
      isSearching: false,
      searchResults: null,
    });
  }

  fetchOpportunitySuccess(data) {
    this.setState({
      opportunity: data,
      opportunities: this.state.opportunities.set(data.id, data),
    });
  }

  fetchOpportunityError(response) {
    console.error(response);
    this.setState({
      opportunity: null,
    });
  }

  onClearSearch() {
    this.setState({
      searchResults: null,
      searchTerm: null,
      isSearching: false,
    });
  }

  onSetSearchTerm(term) {
    this.setState({
      searchTerm: term,
    });
  }

  fetchStagesSuccess(stages) {
    this.setState({
      stages,
    });
  }

  fetchStagesError(resp) {
    console.error(resp);
    this.setState({
      stages: null,
    });
  }
}

export default alt.createStore(CrmOpportunityStore, 'CrmOpportunityStore');
